import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Importing components
import { PlayerLayout } from './layouts';
import { AudioPlayer } from './audio-player';
import { VideoPlayer } from './video-player';
import { Playlist } from './playlist';
// Importing hooks
import { useShallow } from 'zustand/react/shallow';
// Importing store
import { useMediaStore } from '../../store/media.store';
import { PlayerType } from '../../types/player';
// Importing 3rd party dependencies
import { Fragment } from 'react';
// ----------------------------------------------------------------------
export const Player = () => {
    // Adding media store
    const { media } = useMediaStore(useShallow((state) => ({
        media: state.media,
    })));
    // Resolving type issues from chapter type input
    const playerType = (media === null || media === void 0 ? void 0 : media.type)
        ? PlayerType[media.type]
        : undefined;
    return (_jsxs(Fragment, { children: [_jsx(PlayerLayout, { children: playerType === PlayerType.video ? _jsx(VideoPlayer, {}) : _jsx(AudioPlayer, {}) }), _jsx(Playlist, {})] }));
};
